import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

import Button from "@/components/common/input/button";
import Spinner from "@/components/common/spinner";
import { logRejection } from "@/helpers";
import { useAuth } from "@/hooks/auth";
import useRecaptcha from "@/hooks/recaptcha";

const TokenLogin = () => {
  const { user, tokenLogin, error, is_loading, signOut } = useAuth();
  const { token } = useParams();
  const navigate = useNavigate();
  const { hide: reHide, verify: reVerify, loading: reLoading } = useRecaptcha();

  useEffect(() => {
    signOut();
    return () => {
      reHide();
    };
  }, [signOut, reHide]);

  useEffect(() => {
    if (user && user.roles.includes("guest")) {
      const url = new URL(window.location.href);
      // do we have a to param?
      const to_param = url.searchParams.get("to");
      reHide();
      void navigate(to_param ? to_param : "/share", { replace: true });
    }
  }, [user, reHide, navigate]);

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-8">
      {reLoading || is_loading ? (
        <Spinner large />
      ) : (
        <>
          <div className="w-[26rem] font-outfit text-[4.2rem] leading-snug font-medium">
            <img
              src="https://storage.googleapis.com/tacolab-dev-customer-resources/assets/logo/Unfold_logo_white.png"
              alt="Unfold logotype"
            />
          </div>
          <Button
            onClick={() => {
              // The route only matches with a token, so this guard is for the type.
              if (!token) return;
              reVerify()
                .then((result) => tokenLogin(token, result))
                .then(reHide)
                .catch(logRejection);
            }}
          >
            Enter
          </Button>
        </>
      )}
      {error && <div>Something went wrong. Check the link and try again.</div>}
    </div>
  );
};

export default TokenLogin;
